import { SET_USER, USER_STATUS, ADD_ITEM } from "../actions-index";
import Auth from "@aws-amplify/auth";
import { redirectToLogIn, redirectToLogOut } from "../util/util";
import { transformUser } from "./transform";

export function recievedSetUser(user) {
	return {
		type: SET_USER,
		payload: transformUser(user),
	};
}

export function setUserStatus(status) {
	return {
		type: USER_STATUS,
		payload: status,
	};
}

export function addItem2() {
	const seasonlistchecked = JSON.parse(localStorage.getItem("seasonlistchecked"));
	return {
		type: ADD_ITEM,
		payload: seasonlistchecked,
	};
}
export function addItem() {
	return function (dispatch) {
		dispatch(addItem2());
	};
}
export function setUser(forceRedirect = false) {
	return function (dispatch) {
		dispatch(setUserStatus("loading"));
		function validateSession(userResponse) {
			if (userResponse) {
				dispatch(recievedSetUser(userResponse));
			}
			return;
		}

		return Auth.currentSession()
			.then((session) => {
				validateSession(session.idToken.payload);
				if (
					session.idToken.payload.applicationRoles !== "ADMIN" &&
					session.idToken.payload.applicationRoles !== "admin"
				) {
					dispatch(setUserStatus("error"));
					redirectToLogOut();
				}
			})
			.catch((error) => {
				if (forceRedirect && error === "No current user") {
					redirectToLogIn();
				} else {
					setTimeout(() => {
						Auth.currentSession()
							.then((session) => {
								validateSession(session.idToken.payload);
							})
							.catch((error) => {
								setTimeout(() => {
									Auth.currentSession()
										.then((session) => {
											validateSession(session.idToken.payload);
										})
										.catch((error) => {
											console.log(error);
											dispatch(setUserStatus("error"));
										});
								}, 3000); //second wait
							});
					}, 1000);
				}
			});
	};
}
